module.exports = __webpack_public_path__ + "media/images/phone-icon-033f3f2e4bef7b9699d2e864419c2221f00301799a6ae6428c05dae136a04793.svg";